<div class="block__right-side-panel">
    <div class="block-full-width no-padding no-border-radius">
        <div class="edit-profile-account">
            <div class="edit-profile-account-items-area">
                <h2 class="edit-profile-account-items-area__title">
                    {{ 'YOUR_DETAILS' | translate }}
                </h2>

                <form [formGroup]="_customerForm" (ngSubmit)="submitProfile()" ridangoFocusInvalidInput>
                    <div class="edit-profile-account-items-area__item">
                        <ridango-form-field
                            class="form-margin-10"
                            *ngIf="(customerFields$ | async).indexOf('email') >= 0">
                            <input
                                ridangoInput
                                value="{{ (profile$ | async)?.email }}"
                                name="email"
                                type="email"
                                required
                                disabled />
                            <ridango-label id="account-email-label">{{ 'PH_EMAIL' | translate }}</ridango-label>
                        </ridango-form-field>
                    </div>

                    <div class="edit-profile-account-items-area__item">
                        <ridango-form-field
                            class="form-margin-10"
                            *ngIf="(customerFields$ | async).indexOf('name') >= 0">
                            <input
                                [formControl]="_customerForm.controls.name"
                                ridangoInput
                                value="{{ (profile$ | async)?.name }}"
                                name="name"
                                type="text" />
                            <ridango-label>{{ 'PH_ACCOUNT_NAME' | translate }}</ridango-label>
                        </ridango-form-field>
                    </div>

                    <div class="edit-profile-account-items-area__item">
                        <ridango-form-field
                            class="form-margin-10"
                            *ngIf="(customerFields$ | async).indexOf('phone') >= 0">
                            <input
                                [formControl]="_customerForm.controls.phone"
                                ridangoInput
                                value="{{ (profile$ | async)?.phone }}"
                                name="phone"
                                type="tel" />
                            <ridango-label>{{ 'PH_PHONE' | translate }}</ridango-label>
                            <ridango-error
                                *ngIf="
                                    _customerForm.controls.phone.touched &&
                                    _customerForm.controls.phone.hasError('phoneTooShort')
                                ">
                                {{ 'LOCAL_INPUT_VALIDATION_PHONE_TOO_SHORT' | translate }}</ridango-error
                            >
                            <ridango-error
                                *ngIf="
                                    _customerForm.controls.phone.touched &&
                                    _customerForm.controls.phone.hasError('phoneTooLong')
                                ">
                                {{ 'LOCAL_INPUT_VALIDATION_PHONE_TOO_LONG' | translate }}</ridango-error
                            >
                            <ridango-error
                                *ngIf="
                                    _customerForm.controls.phone.touched &&
                                    _customerForm.controls.phone.hasError('invalidPhoneCountryCode')
                                ">
                                {{ 'LOCAL_INPUT_VALIDATION_PHONE_INVALID_COUNTRY_CODE' | translate }}</ridango-error
                            >
                            <ridango-error
                                *ngIf="
                                    _customerForm.controls.phone.touched &&
                                    _customerForm.controls.phone.hasError('invalidPhoneNumber')
                                ">
                                {{ 'LOCAL_INPUT_VALIDATION_PHONE_PATTERN' | translate }}</ridango-error
                            >
                        </ridango-form-field>
                    </div>

                    <div class="edit-profile-account-items-area__item">
                        <ridango-form-field
                            class="form-margin-10"
                            *ngIf="(customerFields$ | async).indexOf('city') >= 0">
                            <input
                                [formControl]="_customerForm.controls.adr_city"
                                ridangoInput
                                name="adr_city"
                                type="text" />
                            <ridango-label>{{ 'PH_CITY' | translate }}</ridango-label>
                        </ridango-form-field>
                    </div>

                    <div class="edit-profile-account-items-area__item">
                        <ridango-form-field
                            class="form-margin-10"
                            *ngIf="(customerFields$ | async).indexOf('street') >= 0">
                            <input
                                [formControl]="_customerForm.controls.adr_street_1"
                                ridangoInput
                                name="adr_street_1"
                                type="text" />
                            <ridango-label>{{ 'PH_STREET_1' | translate }}</ridango-label>
                        </ridango-form-field>
                    </div>

                    <div class="edit-profile-account-items-area__item">
                        <ridango-form-field
                            class="form-margin-10"
                            *ngIf="(customerFields$ | async).indexOf('postal_code') >= 0">
                            <input
                                [formControl]="_customerForm.controls.adr_zip"
                                ridangoInput
                                name="adr_zip"
                                type="text" />
                            <ridango-label>{{ 'PH_POSTAL_CODE' | translate }}</ridango-label>
                            <ridango-error
                                *ngIf="
                                    _customerForm.controls.adr_zip.touched &&
                                    _customerForm.controls.adr_zip.hasError('pattern')
                                ">
                                {{ 'LOCAL_INPUT_VALIDATION_PATTERN' | translate }}</ridango-error
                            >
                        </ridango-form-field>
                    </div>

                    <div class="edit-profile-account-items-area__footer">
                        <div class="edit-profile-account-items-area__right">
                            <button
                                class="btn btn--maximal btn--primary btn--big"
                                *ngIf="loaded$ | async"
                                type="submit">
                                {{ 'SAVE_DETAILS' | translate }}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
